<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/partnerProductAccountDetail', query: { id: this.$route.query.ppa_rid } }"
                    >合作产品路径详情</el-breadcrumb-item
                >
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="insert">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="update">编辑</el-button>
                    <el-button size="small" plain @click="del">删除</el-button>
                    <draggableDetail :draggable="{ data_name: 'commodity_flow_state_init' }" @isErrshow="reload"></draggableDetail>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div class="read_only read_only_link" v-if="in_array(item.prop, ['xxxxx'])">
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
export default {
    inject: ['reload'],
    name: 'commodityFlowStateInitDetail',
    components: {
        draggableDetail
    },
    data() {
        return {
            colData: [],
            activeNames: ['1'],
            data: {},
            queryParams: {},
            headerTitle: '合作产品路径初始化详情'
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.id;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.$nextTick(() => {
            this.getData(); //获取详情
        });
    },
    methods: {
        in_array,
        toDetail(prop) {},
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).commodity_flow_state_init;
            processColumnDataToRowNew(colData, this);
        },
        //删除
        del() {
            onDelete(
                this.data.id,
                this,
                'commodityFlowStateInitDelete',
                this.data.rid,
                'partnerProductAccountDetail?id=' + this.$route.query.ppa_rid
            );
        },
        //编辑
        update() {
            this.$router.push({
                path: 'commodityFlowStateInitEdit',
                query: {
                    type: 'update',
                    id: this.data.rid,
                    ppa_rid: this.data.ppa_rid
                }
            });
        },
        //新增
        insert() {
            this.$router.push({
                path: 'commodityFlowStateInitEdit',
                query: {
                    type: 'insert',
                    ppa_rid: this.$route.query.ppa_rid
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'commodityFlowStateInitEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid,
                    ppa_rid: this.data.ppa_rid
                }
            });
        },
        //详情
        getData() {
            this.$api
                .commodityFlowStateInitDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.rid;
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>